
const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg:        #dde4ec;
    --skel-base: #e2e6ec;
    --skel-shine:#f0f3f7;
    --white:     #ffffff;
    --radius-lg: 20px;
    --radius-md: 14px;
    --radius-sm: 8px;
    --shadow:    0 4px 24px rgba(0,0,0,0.08);
    --shadow-sm: 0 2px 12px rgba(0,0,0,0.06);
  }

  body { font-family: 'DM Sans', sans-serif; background: var(--bg); }

  @keyframes shimmer {
    0%   { background-position: -700px 0; }
    100% { background-position:  700px 0; }
  }
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .s {
    background: linear-gradient(90deg,
      var(--skel-base) 25%, var(--skel-shine) 50%, var(--skel-base) 75%
    );
    background-size: 700px 100%;
    animation: shimmer 1.7s ease-in-out infinite;
    border-radius: 6px;
    flex-shrink: 0;
  }

  /* Shell */
  .shell {
    display: flex;
    min-height: 100vh;
    background: var(--bg);
    padding: 16px;
    gap: 16px;
    align-items: flex-start;
  }

  /* ── Sidebar ── */
  .sidebar {
    width: 220px; flex-shrink: 0;
    height: calc(100dvh - 32px);
    background: var(--white);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow);
    padding: 20px 14px;
    position: sticky; top: 16px;
    display: flex; flex-direction: column; gap: 6px;
    animation: fadeUp .4s ease both;
  }

  .sidebar__logo {
    display: flex; flex-direction: column; gap: 6px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--skel-base);
    margin-bottom: 10px;
  }

  .sb-logo-icon { width:36px; height:36px; border-radius:10px; }
  .sb-logo-text { width:100px; height:14px; }
  .sb-logo-sub  { width:70px; height:9px; }
  .sb-create    { width:100%; height:36px; border-radius:var(--radius-sm); margin-bottom:8px; }

  .nav-item {
    display:flex; align-items:center; gap:10px;
    padding:9px 10px; border-radius:var(--radius-sm);
    animation: fadeUp .4s ease both;
  }
  .nav-item--active { background: var(--skel-base); }
  .nav-icon  { width:18px; height:18px; border-radius:5px; }
  .nav-label { height:11px; border-radius:4px; }

  /* ── Main ── */
  .main { flex:1; min-width:0; display:flex; flex-direction:column; gap:14px; }

  /* ── Topbar (floating, rounded) ── */
  .topbar {
    background: var(--white);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow);
    padding: 14px 20px;
    display: flex; align-items: center; justify-content: space-between; gap:12px;
    position: sticky; top: 16px; z-index: 10;
    animation: fadeUp .3s ease both;
  }
  .topbar__left { display:flex; align-items:center; gap:12px; }
  .topbar__right { display:flex; align-items:center; gap:10px; flex-shrink:0; }

  .tb-icon   { width:38px; height:38px; border-radius:10px; }
  .tb-title  { width:100px; height:16px; }
  .tb-sub    { width:140px; height:10px; margin-top:5px; }
  .tb-badge  { width:150px; height:36px; border-radius:20px; }
  .tb-avatar { width:38px; height:38px; border-radius:50%; }

  /* mobile topbar extras */
  .tb-logo-mob  { width:38px; height:38px; border-radius:50%; }
  .tb-badge-mob { flex:1; height:36px; border-radius:20px; min-width:0; }

  /* ── Search ── */
  .search-wrap {
    background: var(--white);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    padding: 10px 16px;
    display: flex; align-items: center; gap: 10px;
    animation: fadeUp .35s ease both;
  }
  .search-icon   { width:18px; height:18px; border-radius:50%; }
  .search-bar    { flex:1; height:14px; border-radius:6px; }
  .search-count  { width:28px; height:28px; border-radius:50%; }
  .search-filter { width:28px; height:28px; border-radius:8px; }

  /* ── Table card ── */
  .table-card {
    background: var(--white);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    animation: fadeUp .4s ease both;
  }

  /* Desktop table head */
  .table-head {
    background: var(--skel-base);
    padding: 14px 20px;
    display: flex; gap: 16px; align-items: center;
  }
  .th {
    height: 12px; border-radius: 4px;
    background: linear-gradient(90deg, var(--skel-shine) 25%, #fff 50%, var(--skel-shine) 75%);
    background-size: 700px 100%;
    animation: shimmer 1.7s ease-in-out infinite;
  }

  /* Desktop rows */
  .table-row {
    display: flex; align-items: center; gap: 16px;
    padding: 14px 20px;
    border-bottom: 1px solid var(--skel-base);
    animation: fadeUp .4s ease both;
  }
  .table-row:last-child { border-bottom: none; }

  .row-check  { width:18px; height:18px; border-radius:4px; }
  .row-avatar { width:36px; height:36px; border-radius:50%; }
  .row-name   { height:13px; border-radius:4px; }
  .row-sub    { height:10px; border-radius:4px; margin-top:4px; }
  .row-cell   { height:13px; border-radius:4px; }
  .row-action { width:32px; height:32px; border-radius:50%; }

  .name-col   { flex:1.4; display:flex; align-items:center; gap:10px; min-width:0; }
  .name-lines { flex:1; min-width:0; }
  .col-contact { flex:1; }
  .col-email   { flex:1.2; }
  .col-source  { flex:0.8; }

  /* Mobile card rows */
  .mobile-list { display:flex; flex-direction:column; }
  .mob-row {
    display:flex; align-items:center; gap:12px;
    padding:14px 16px;
    border-bottom:1px solid var(--skel-base);
    animation: fadeUp .4s ease both;
  }
  .mob-row:last-child { border-bottom:none; }
  .mob-check  { width:18px; height:18px; border-radius:4px; }
  .mob-avatar { width:42px; height:42px; border-radius:50%; }
  .mob-info   { flex:1; min-width:0; }
  .mob-name   { height:14px; border-radius:4px; }
  .mob-phone  { height:11px; border-radius:4px; margin-top:5px; }
  .mob-dots   { width:34px; height:34px; border-radius:50%; }
  .mob-chev   { width:34px; height:34px; border-radius:50%; }

  /* Bottom nav */
  .bottom-nav {
    position: fixed; bottom:12px; left:12px; right:12px;
    background: var(--white);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow);
    padding: 10px 8px;
    display: flex; align-items: center; justify-content: space-around;
    z-index: 20;
  }
  .bn-item { display:flex; flex-direction:column; align-items:center; gap:5px; }
  .bn-icon  { width:22px; height:22px; border-radius:6px; }
  .bn-label { width:38px; height:9px; border-radius:4px; }
  .bn-plus  { width:48px; height:48px; border-radius:50%; }

  /* ── Responsive ── */

  /* Mobile < 640 */
  @media (max-width: 639px) {
    .shell { padding: 12px 10px 90px; }
    .sidebar { display: none; }
    .tb-icon, .tb-title, .tb-sub, .tb-badge, .tb-avatar { display: none; }
    .tb-logo-mob  { display: flex !important; }
    .tb-badge-mob { display: flex !important; }
    .tb-avatar-mob { display: flex !important; }
    .desktop-table { display: none !important; }
    .mobile-list   { display: flex !important; }
    .bottom-nav    { display: flex !important; }
  }

  /* Tablet 640–1023 */
  @media (min-width: 640px) and (max-width: 1023px) {
    .shell { padding: 14px 14px 90px; }
    .sidebar { display: none; }
    .tb-icon, .tb-title, .tb-sub { display: none; }
    .tb-logo-mob  { display: flex !important; }
    .tb-badge-mob { display: flex !important; }
    .tb-avatar-mob { display: flex !important; }
    .desktop-table { display: none !important; }
    .mobile-list   { display: flex !important; }
    .bottom-nav    { display: flex !important; }
  }

  /* Desktop ≥ 1024 */
  @media (min-width: 1024px) {
    .tb-logo-mob, .tb-badge-mob, .tb-avatar-mob { display: none !important; }
    .sidebar { display: flex; }
    .desktop-table { display: block !important; }
    .mobile-list   { display: none !important; }
    .bottom-nav    { display: none !important; }
  }

  /* Default hide (overridden by media queries) */
  .desktop-table { display: block; }
  .mobile-list   { display: none; }
  .bottom-nav    { display: none; }
  .tb-logo-mob   { display: none; }
  .tb-badge-mob  { display: none; }
  .tb-avatar-mob { display: none; }
`;

const NAV = [
  {w:55},{w:75,active:true},{w:65},{w:88},
  {w:105},{w:90},{w:70},{w:65},{w:80},{w:72},{w:82},
];

const ROWS = [
  {name:80, sub:55, phone:95, email:120, src:55},
  {name:65, sub:45, phone:80, email:100, src:55},
  {name:110,sub:70, phone:95, email:130, src:35},
  {name:90, sub:58, phone:88, email:115, src:55},
  {name:75, sub:50, phone:90, email:105, src:30},
  {name:100,sub:65, phone:95, email:125, src:55},
  {name:85, sub:55, phone:82, email:110, src:55},
  {name:120,sub:75, phone:95, email:145, src:43},
  {name:92, sub:60, phone:88, email:118, src:55},
];

export default function SkeletonLoader() {
  return (
    <>
      <style>{css}</style>
      <div className="shell">

        {/* Sidebar */}
        <aside className="sidebar">
          <div className="sidebar__logo">
            <div className="s sb-logo-icon" />
            <div className="s sb-logo-text" />
            <div className="s sb-logo-sub"  />
          </div>
          <div className="s sb-create" />
          {NAV.map((n,i)=>(
            <div key={i} className={`nav-item${n.active?" nav-item--active":""}`}
                 style={{animationDelay:`${i*35}ms`}}>
              <div className="s nav-icon" />
              <div className="s nav-label" style={{width:n.w}} />
            </div>
          ))}
        </aside>

        {/* Main */}
        <div className="main">

          {/* Topbar */}
          <header className="topbar">
            <div className="topbar__left">
              {/* Desktop */}
              <div className="s tb-icon" />
              <div>
                <div className="s tb-title" />
                <div className="s tb-sub"   />
              </div>
              {/* Mobile/Tablet */}
              <div className="s tb-logo-mob"  />
              <div className="s tb-badge-mob" />
            </div>
            <div className="topbar__right">
              <div className="s tb-badge"  />
              <div className="s tb-avatar" />
              <div className="s tb-avatar-mob" style={{width:38,height:38,borderRadius:"50%"}} />
            </div>
          </header>

          {/* Search */}
          <div className="search-wrap">
            <div className="s search-icon"   />
            <div className="s search-bar"    />
            <div className="s search-count"  />
            <div className="s search-filter" />
          </div>

          {/* Desktop Table */}
          <div className="table-card desktop-table">
            <div className="table-head">
              <div style={{width:18,height:18,borderRadius:4,background:"var(--skel-shine)",flexShrink:0}} />
              <div className="th" style={{flex:1.4}} />
              <div className="th" style={{flex:1}}   />
              <div className="th" style={{flex:1.2}} />
              <div className="th" style={{flex:0.8}} />
              <div className="th" style={{width:60}} />
            </div>
            {ROWS.map((r,i)=>(
              <div key={i} className="table-row" style={{animationDelay:`${i*55}ms`}}>
                <div className="s row-check"  />
                <div className="name-col">
                  <div className="s row-avatar" />
                  <div className="name-lines">
                    <div className="s row-name" style={{width:r.name}} />
                    <div className="s row-sub"  style={{width:r.sub}}  />
                  </div>
                </div>
                <div className="col-contact"><div className="s row-cell" style={{width:r.phone}} /></div>
                <div className="col-email">  <div className="s row-cell" style={{width:r.email}} /></div>
                <div className="col-source"> <div className="s row-cell" style={{width:r.src}}   /></div>
                <div><div className="s row-action" /></div>
              </div>
            ))}
          </div>

          {/* Mobile/Tablet List */}
          <div className="table-card mobile-list">
            {ROWS.map((r,i)=>(
              <div key={i} className="mob-row" style={{animationDelay:`${i*55}ms`}}>
                <div className="s mob-check"  />
                <div className="s mob-avatar" />
                <div className="mob-info">
                  <div className="s mob-name"  style={{width:r.name}}  />
                  <div className="s mob-phone" style={{width:r.phone}} />
                </div>
                <div className="s mob-dots" />
                <div className="s mob-chev" />
              </div>
            ))}
          </div>

        </div>

        {/* Bottom Nav */}
        <nav className="bottom-nav">
          {["Member","Enquiry","plus","Follow Up","More"].map((label,i)=>
            label==="plus" ? (
              <div key={i} className="s bn-plus" />
            ) : (
              <div key={i} className="bn-item">
                <div className="s bn-icon"  />
                <div className="s bn-label" />
              </div>
            )
          )}
        </nav>

      </div>
    </>
  );
}
